import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { SharedHero } from '@hover/shared-components';
import {
  HeaderDescription,
  Layout,
  ReadyToSeeWithImage,
  UtilityMenuBanner,
} from '../../v2/components/common';
import { URLS } from '../../v2/constants';
import MarketingAndSales from '../../v2/components/vinyl-siding-estimator/MarketingAndSales';
import FAQ from '../../v2/components/vinyl-siding-estimator/FAQ';
import RoofingCalculator from '../../v2/components/how-to-measure-a-roof/RoofingCalculator';
import SidingMaterials from '../../v2/components/vinyl-siding-estimator/siding-materials';

const VinylSlidingEstimator: React.FC = () => (
  <Layout
    buttonType="SCHEDULE_A_DEMO"
    title="Vinyl Siding Calculator & Cost Estimator"
    description="Use HOVER’s free siding calculator to determine how much siding your home needs. Visualize siding updates in 3D using the HOVER app. Try for free today!"
    bannerElement={<UtilityMenuBanner />}
  >
    <SharedHero
      heading="Home Siding Calculator & 3D Estimator"
      body="Use HOVER to get accurate measurement for any siding job -- all from just a few photos with your phone. Calculate the materials needed, estimate labor costs, and visualize the finished project using an interactive 3D model."
      chatWithUsLink={URLS.vinylSidingEstimator.chatWithUs}
      desktopImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/vinyl-siding-estimator_hero_desktop.jpg"
          alt="page hero"
        />
      }
      mobileAndTabletImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/vinyl-siding-estimator_hero_mobile.jpg"
          alt="page hero"
        />
      }
      page="vinyl-siding-estimator"
    />
    <HeaderDescription
      mb={{ base: 1000, tablet: 1100, desktop: '152px' }}
      body="Gathering accurate siding measurements is an important part of home renovation. With HOVER’s home siding estimator, you’ll be well on your way to understanding the precise amount of siding needed for any siding job. This will help estimate siding materials needed and an accurate siding cost estimator. Follow step-by-step instructions below to easily estimate siding for your house. If you find this guide helpful, you may also enjoy our guide on roof measurements."
    />
    <MarketingAndSales />
    <RoofingCalculator testId="vinyl-siding-est-calculator" />
    <SidingMaterials />
    <FAQ />
    <ReadyToSeeWithImage
      testId="vinyl-siding-estimator"
      bg="brandNavy.500"
      image={
        <StaticImage
          placeholder="blurred"
          alt="Measure roof - ready to see"
          src="../../v2/assets/images/measure_roof_ready_to_see.png"
        />
      }
      body="Get a free 3D model of your home today."
      headingColor="neutral.0"
      bodyColor="neutral.0"
      buttonProps={{
        colorScheme: 'brandNavy',
        variant: 'inverted',
      }}
    />
  </Layout>
);

export default VinylSlidingEstimator;
